import React, { useState, useEffect } from 'react';
import Icon from '../../../components/AppIcon';

const AchievementTicker = ({ achievements }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isGlitching, setIsGlitching] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      setIsGlitching(true);
      setTimeout(() => {
        setCurrentIndex((prev) => (prev + 1) % achievements?.length);
        setIsGlitching(false);
      }, 300);
    }, 5000);

    return () => clearInterval(interval);
  }, [achievements?.length]);

  const currentAchievement = achievements?.[currentIndex];

  return (
    <div className="achievement-ticker bg-card border-2 border-secondary rounded-sm p-4 md:p-5 lg:p-6 shadow-glow-magenta-md overflow-hidden">
      <div className="flex items-center gap-3 md:gap-4 mb-3 md:mb-4">
        <Icon name="Award" size={24} color="var(--color-secondary)" />
        <h3 className="text-sm md:text-base lg:text-lg font-heading font-bold text-secondary tracking-wide">
          RECENT ACHIEVEMENTS
        </h3>
      </div>
      <div className={`
        transition-all duration-300
        ${isGlitching ? 'glitch-effect opacity-50' : 'opacity-100'}
      `}>
        <div className="flex items-start gap-3 md:gap-4">
          <div className="flex-shrink-0 w-12 h-12 md:w-14 md:h-14 lg:w-16 lg:h-16 bg-secondary/20 rounded-sm flex items-center justify-center border border-secondary">
            <Icon name={currentAchievement?.icon} size={28} color="var(--color-secondary)" />
          </div>
          <div className="flex-1 min-w-0">
            <h4 className="text-sm md:text-base lg:text-lg font-heading font-bold text-foreground mb-1">
              {currentAchievement?.title}
            </h4>
            <p className="text-xs md:text-sm font-caption text-muted-foreground line-clamp-2">
              {currentAchievement?.description}
            </p>
            <div className="flex items-center gap-2 mt-2">
              <Icon name="Clock" size={14} color="var(--color-muted-foreground)" />
              <span className="text-xs font-data text-muted-foreground">
                {currentAchievement?.timestamp}
              </span>
            </div>
          </div>
        </div>
      </div>
      <div className="flex items-center justify-center gap-2 mt-4">
        {achievements?.map((_, index) => (
          <div
            key={index}
            className={`
              w-2 h-2 rounded-sm transition-all duration-base
              ${index === currentIndex 
                ? 'bg-secondary w-6' :'bg-secondary/30'
              }
            `}
          />
        ))}
      </div>
    </div>
  );
};

export default AchievementTicker;